import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetOLT } from '@/shared/actions/erp';
import { SaveOLTComponent } from '../../shared/components/SaveOLTComponent';
import { LoaderComponent } from '@/shared/components/ui';

export interface UpdateOltPageProps { }

const UpdateOltPage: React.FC<UpdateOltPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_olt);
  const returnUrlOLTsPage = ROUTER_PATHS.configuracionRED.oltNav;

  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetOLT(id!);

  if (isLoading || isRefetching) return null;

  if (!data?.data?.id_olt)
    return <Navigate to={returnUrlOLTsPage} />;

  if (isLoading) 
    return <LoaderComponent />

  return <SaveOLTComponent title={`Editar OLT - ${data?.data?.nombre || "..."}`} olt={data.data} />;
};

export default UpdateOltPage;
